
/* styles */
require("!!../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-85aa9308&scoped=true!sass-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./ativar-tag-item.vue")

var Component = require("!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./ativar-tag-item.vue"),
  /* template */
  require("!!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-85aa9308!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./ativar-tag-item.vue"),
  /* scopeId */
  "data-v-85aa9308",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/ativar-tag/ativar-tag-item.vue
// module id = 521
// module chunks = 1